module.exports = __webpack_public_path__ + "img/PL08187.641229cd.png";